import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {},

  listItemDiv: {
    width: "100%",
    overflow: "auto",
  },
  creditCardTerminalSelectionContainer: {
    margin: theme.spacing(2)
  },
  creditCardTerminalDropdown: {
    marginTop: theme.spacing(1),
  },
  listSubHeader:{
    fontWeight: "bold",
    color:theme.palette.primary.dark,
    paddingLeft:theme.spacing(1),
    textAlign:"Left",
    PointerEvent:"none",
    userSelect:"none",
  }
}));
